/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Purpose_2Inputs */

const da_privacy_purpose_2 = /** @type {(inputs: Privacy_Purpose_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drift, sikkerhed, fejlretning, forbrugsgrænser, support og forbedring af tjenesten, herunder at tælle besøg, uden at vi kan genkende den enkelte: vores legitime interesse (art. 6, stk. 1, litra f).`)
};

/** @type {(inputs: Privacy_Purpose_2Inputs) => LocalizedString} */
const en_privacy_purpose_2 = da_privacy_purpose_2;

/**

* @param {Privacy_Purpose_2Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_purpose_2 = /** @type {((inputs?: Privacy_Purpose_2Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Purpose_2Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_purpose_2(inputs)
	return /** @type {LocalizedString} */ ("Drift, sikkerhed, fejlretning, forbrugsgrænser, support og forbedring af tjenesten, herunder at tælle besøg, uden at vi kan genkende den enkelte: vores legitime interesse (art. 6, stk. 1, litra f).")
});